export default {


  setDegree(state, data) {
    state.degree = data;
  },

  setCollaborationType(state, data) {
    state.collaborationType = data;
  },

  setCompanyField(state, data) {
    state.companyField = data;
  },

  setSocialNetwork(state, data) {
    state.socialNetwork = data;
  },
  
  setJobAdvertisement(state, data) {
    state.jobAdvertisement = data;
  },
  setJobAdvertisementById(state, data) {
    state.jobAdvertisementById = data;
  },
  setJobRequest(state, data) {
    state.jobRequest = data;
  },
  setJobRequestById(state, data) {
    state.jobRequestById = data;
  },


};
